
export default {
  name: 'base-nav-item',
  props: {
    link: { type: [String, Object], default: '/' },
    title: { type: String, default: '' },
  },
};
